import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import PageHeader from '../../view/pageheader';
import InputComponent from '../../fields/InputComponent'
import SelectComponent from '../../fields/SelectComponent';
import ButtonComponent from '../../fields/ButtonComponent';
import CardComponent from '../../fields/CardComponent';
import {
    getSubscriptionList,
    addSubscription,
    getSubscriptionData,
    updateSubscription,
    subscriptionStatus,
    deleteSubscription,
    resetSuccessFlag
} from "../../store/reducer/subscriptionSlice";
import { toast } from 'react-toastify';
import ReactQuill from "react-quill";
import { Radio } from "antd";
const AddEditPlan = () => {

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }, { font: [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            ['link'],
            ['clean']

        ],
        clipboard: {
            matchVisual: false
        }
    };

    const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'color', 'background',
        'list', 'bullet', 'indent',
        'align',
        'link',
    ];

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const [, forceUpdate] = useState();  // Use state to trigger re-renders
    const [touchedFields, setTouchedFields] = useState({});
    console.log(id, 'id');

    const [planDetails, setPlanDetails] = useState({
        id: '',
        plan_name: '',
        plan_type: '',
        plan_price: '',
        validity: '',
        plan_description: '',
        status: 1,
        max_properties: 0,
        max_items: 0
    });
    const [status, setStatus] = useState([
        {
            value: 1,
            label: 'Active',
        },
        {
            value: 0,
            label: 'Inactive',
        }
    ])
    const [type, setType] = useState('add')

    //Selectors
    const { addSubscriptionLoading, addSubscriptionError, addedSubscription, addSubscriptionSuccess, updateSubscriptionSuccess, getAddedData, subscriptionErrorMessages } = useSelector((state) => state.subscription);
    console.log(getAddedData, 'getAddedData');

    const { statesListData, statesListLoading, statesError, statesErrorMessage } = useSelector((state) => state.states);

    const validator = useRef(new SimpleReactValidator({
        className: 'validation-message',
        messages: {
            required: 'Please enter :attribute',
            alpha: ':attribute should contain only alphabets',
            regex: ':attribute format is invalid',
            in: 'Confirm password does not match with password field',
            min: ':attribute must be at least :min characters',
            confirmed: 'Passwords do not match',
            strong_password: 'Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a number, and a special character'
        },
        validators: {
            strong_password: { // name the validator
                message: 'Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a number, and a special character',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/) && params.indexOf(val) === -1;
                },
                required: true // This is an optional parameter. If true, the field will be required.
            }
        }
    }));

    const validationRules = {
        plan_name: `required|alphanumeric`,
        plan_price: planDetails.plan_type == "price" ? `required|numeric` : '',
        plan_type: `required`,
        validity: `required|numeric`,
        plan_description: `required`,
        status: `required|numeric`,
        max_properties: `required|numeric`,
        max_items: `required|numeric`
    };

    const addEditUserDetails = (e) => {
        const { name, value } = e.target;
        setPlanDetails(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validator.current.allValid()) {
            let postData = planDetails
            if (type === 'add') {
                console.log(planDetails, 'planDetails');
                delete postData.id
                dispatch(addSubscription({ postData }));
            }
            else {
                let updateID = atob(id)
                console.log(updateID, 'updateID');
                dispatch(updateSubscription({ postData, updateID }));
            }
        } else {
            validator.current.showMessages();
            forceUpdate(1);
        }
    };

    const reset = () => {
        setPlanDetails({
            ...planDetails,
            id: '',
            plan_name: '',
            plan_type: '',
            plan_price: '',
            validity: '',
            plan_description: '',
            status: 1,
            max_properties: 0,
            max_items: 0
        })

    }

    const onChange = (value, name) => {
        setPlanDetails(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const editDescriptionDetails = (value) => {
        setPlanDetails(prevState => ({
            ...prevState,
            plan_description: value
        }));
    }
    const onSearch = (value) => {
        console.log('search:', value);
    };

    useEffect(() => {
        if (addSubscriptionSuccess) {
            setPlanDetails({
                ...planDetails,
                id: '',
                plan_name: '',
                plan_type: '',
                plan_price: '',
                validity: '',
                plan_description: '',
                status: 1,
                max_properties: 0,
                max_items: 0
            })
            toast.success('Subscription added Successfully!');
            dispatch(resetSuccessFlag({ flag: 'addSubscriptionSuccess' }));
            navigate('/subscription/plan');
        }
        if (updateSubscriptionSuccess) {
            setPlanDetails({
                ...planDetails,
                id: '',
                plan_name: '',
                plan_type: '',
                plan_price: '',
                validity: '',
                plan_description: '',
                status: 1,
                max_properties: 0,
                max_items: 0
            })
            toast.success('Subscription Updated Successfully!');
            dispatch(resetSuccessFlag({ flag: 'updateSubscriptionSuccess' }));
            navigate('/subscription/plan');

        }
        if (subscriptionErrorMessages) {
            toast.error(subscriptionErrorMessages)
        }
    }, [addSubscriptionSuccess, updateSubscriptionSuccess, subscriptionErrorMessages, dispatch, navigate]);

    useEffect(() => {
        if (id) {
            setType('edit')
            const decodedId = atob(id); // Use a different variable name
            dispatch(getSubscriptionData({ id: decodedId }));
        }
        else {
            setType('add')
            setPlanDetails({
                ...planDetails,
                id: '',
                plan_name: '',
                plan_type: '',
                plan_price: '',
                validity: '',
                plan_description: '',
                status: 1,
                max_properties: 0,
                max_items: 0
            })
        }
    }, [id, dispatch]);

    useEffect(() => {

        if (getAddedData && type === 'edit') {
            setPlanDetails({
                ...planDetails,
                id: getAddedData.id,
                plan_name: getAddedData?.plan_name,
                plan_type: getAddedData?.plan_type,
                plan_price: getAddedData?.plan_price,
                validity: getAddedData?.validity,
                plan_description: getAddedData?.plan_description,
                status: getAddedData?.status,
                max_properties: getAddedData?.max_properties,
                max_items: getAddedData?.max_items
            })
        }
    }, [getAddedData, type])


    console.log(planDetails, 'planDetails');

    return (
        <div className="container-fluid-subscription" >
            <PageHeader
                HeaderText={type === 'add' ? 'Add Subscription' : 'Update Subscription'}
                Breadcrumb={[{ name: type === 'add' ? 'Add Subscription' : 'Update Subscription' }]}
                backButtonUrl={`/subscription/plan`}
            />
            <CardComponent>
                <div class="grid-container">
                    <div class="grid-item col-span-1">
                        <div>
                            <label htmlFor="plan_name">Subscription Plan Name</label><span className='m-1' style={{ color: 'red' }}>*</span>
                            <InputComponent
                                name="plan_name"
                                placeholder="Enter Plan Name"
                                type="text"
                                value={planDetails.plan_name}
                                onChange={addEditUserDetails}
                                validator={validator}
                                touchedFields={touchedFields}
                                validationRules={validationRules}
                            />
                        </div>
                    </div>
                    <div class="grid-item col-span-1">
                        <div>
                            <label htmlFor="plan_type">Select Plan Type</label><span className='m-1' style={{ color: 'red' }}>*</span><br />
                            <Radio.Group
                                name="plan_type"
                                value={planDetails.plan_type}
                                onChange={addEditUserDetails}
                                validator={validator}
                                touchedFields={touchedFields}
                                validationRules={validationRules}
                            >
                                <Radio value={"free"}>Free</Radio>
                                <Radio value={"paid"}>Paid </Radio>
                            </Radio.Group>
                        </div>
                    </div>
                    <div class="grid-item col-span-1">
                        <div>
                            <label htmlFor="plan_price">Plan Price ($) </label>
                            <span className="m-1" style={{ color: 'red' }}>* {planDetails.plan_type == "free" ? "- Change Plan Type to Enter Price" : ""}</span><br />
                            <InputComponent
                                name="plan_price"
                                placeholder="Enter Plan Price"
                                type="text"
                                disabled={planDetails.plan_type === "free" ? true : false}
                                value={planDetails.plan_price}
                                onChange={addEditUserDetails}
                                validator={validator}
                                touchedFields={touchedFields}
                                validationRules={validationRules}
                            />
                        </div>
                    </div>
                    <div class="grid-item col-span-1">
                        <div>
                            <label htmlFor="validity">Plan Validity (Days)</label><span className='m-1' style={{ color: 'red' }}>*</span>
                            <InputComponent
                                name="validity"
                                placeholder="Plan Validity in days"
                                type="text"
                                value={planDetails.validity}
                                onChange={addEditUserDetails}
                                validator={validator}
                                touchedFields={touchedFields}
                                validationRules={validationRules}
                            />
                        </div>
                    </div>
                    <div class="grid-item col-span-1">
                        <div>
                            <label htmlFor="max_properties">No. of Properties (Max Count)</label><span className='m-1' style={{ color: 'red' }}>*</span>
                            <InputComponent
                                name="max_properties"
                                placeholder="No. of Properties"
                                type="number"
                                value={planDetails.max_properties}
                                onChange={addEditUserDetails}
                                validator={validator}
                                touchedFields={touchedFields}
                                validationRules={validationRules}
                            />
                        </div>
                    </div>
                    <div class="grid-item col-span-1">
                        <div>
                            <label htmlFor="max_items">No. of Room Items (Max Count)</label>
                            <span className="m-1" style={{ color: 'red' }}>*</span><br />

                            <InputComponent
                                name="max_items"
                                placeholder="No. of Room Items"
                                type="number"
                                value={planDetails.max_items}
                                onChange={addEditUserDetails}
                                validator={validator}
                                touchedFields={touchedFields}
                                validationRules={validationRules}
                            />
                        </div>
                    </div>
                    <div class="grid-item col-span-1">
                        <div>
                            <label htmlFor="name">Status</label>
                            <span className="m-1" style={{ color: 'red' }}>*</span><br />
                            <SelectComponent
                                name="status"
                                value={planDetails.status}
                                placeholder="Please choose subscription status"
                                onChange={(value) => onChange(value, 'status')}
                                onSearch={onSearch}
                                options={status}
                                validator={validator}
                                touchedFields={touchedFields}
                                validationRules={validationRules}
                            />
                        </div>
                    </div><br />

                    <div className='col-md-12 grid-item col-span-2'>
                        <label for="plan_description">Plan Description</label>
                        <span className="m-1" style={{ color: 'red' }}>*</span><br />

                        <ReactQuill theme="snow" modules={modules} formats={formats} value={planDetails.plan_description} onChange={editDescriptionDetails} />
                    </div>

                </div>
                <div className='text-center mt-3'>
                    <ButtonComponent style={{ backgroundColor: '#f7931e', color: 'white' }} onClick={handleSubmit} buttonName={type === 'add' ? 'Add Subscription Plan' : 'Update Subscription Plan'} icon={<i class="fa fa-list-alt" aria-hidden="true"></i>} />&nbsp;
                    <ButtonComponent style={{ backgroundColor: '#6E6E6E', color: 'white' }} onClick={reset} buttonName="Reset" icon={<i class="fa fa-refresh" aria-hidden="true"></i>} />
                </div>
            </CardComponent>
            {/* </Card> */}
        </div>
    )
}

export default AddEditPlan